import React from 'react';
import styled from 'styled-components';
import Header from '../../components/menus/Header/Header';
import { createFragmentContainer, graphql } from 'react-relay';
import { Wrapper_viewer } from './__generated__/Wrapper_viewer.graphql';
import { Wrapper_account } from './__generated__/Wrapper_account.graphql';
import Footer from '../../components/Footer';

const Page = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

type Props = {
  children?: React.ReactNode;
  viewer: Wrapper_viewer;
  account: Wrapper_account;
};

function Wrapper({ children, viewer, account }: Props) {
  return (
    <Page>
      <Header viewer={viewer} account={account} />
      {children}
      <Footer />
    </Page>
  );
}

export default createFragmentContainer(Wrapper, {
  viewer: graphql`
    fragment Wrapper_viewer on User {
      id
      email
      ...Header_viewer
    }
  `,
  account: graphql`
    fragment Wrapper_account on Account {
      ...Header_account
    }
  `,
});
